export default __webpack_public_path__ + "static/media/@julianelimamancini.3925407b.jpg";